import React from 'react';
import appstoreShowcase from '../assets/appstore_showcase.png';
import PlayStoreIcon from './PlayStoreIcon';
import { Sparkles } from 'lucide-react';

export default function AppStore() {
  return (
    <section id="cta" className="py-20 px-6 max-w-7xl mx-auto text-center relative">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-gradient-to-tr from-[#E63946]/10 to-[#F6D365]/5 rounded-full blur-3xl pointer-events-none -z-10" />

      <div className="inline-flex items-center gap-2 bg-[#161B26] border border-gray-800 px-4 py-1.5 rounded-full text-sm font-semibold text-[#F6D365] mb-4">
        <Sparkles className="w-4 h-4" /> Official Release
      </div>

      <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight mb-4">
        Now Available on <span className="text-[#E63946]">Google Play Store</span>
      </h2>

      <p className="text-gray-400 max-w-xl mx-auto text-base mb-12">
        Experience seamless AI photo &amp; video processing instantly on your Android device. Free download, endless creative possibilities.
      </p>

      {/* <div className="relative max-w-3xl mx-auto rounded-[36px] p-2 bg-gradient-to-b from-gray-800/40 to-transparent border border-gray-800/80 shadow-2xl overflow-hidden group">
        <div className="absolute inset-0 bg-[#E63946]/5 group-hover:bg-[#E63946]/10 transition-colors duration-500 pointer-events-none" />
        
        {/* <img
          src={appstoreShowcase}
          alt="PFP AI Studio Google Play Listing Showcase"
          className="w-full h-auto rounded-[30px] block object-cover transition-transform duration-700 group-hover:scale-[1.02]"
        /> 
      </div> */}

      <div className="mt-12">
        <a
          href="https://play.google.com/store/apps/details?id=com.pfpaiapp&pcampaignid=web_share"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block focus:outline-none"
        >
          <PlayStoreIcon className="h-80 md:h-80 w-auto drop-shadow-xl" />
        </a>
      </div>
    </section>
  );
}
